<div class="auth-page-container">
    <h2 mat-dialog-title class="join-header">
        <div class="j-header-content">
            <section class="flex-row-gap align-item-center">
                <img src="../../../../../assets/images/oe-logo-full.png" alt="logo">
                <span>{{'pleaseComplt' | translate}}</span>
            </section>

            <button class="btn float-end mt-2 form-close-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                        fill="#BAB5B5" />
                </svg>
            </button>
        </div>
    </h2>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography join-box-body">
        <form class="join-form-box" [formGroup]="updateJoinForm" (ngSubmit)="onSubmitData()">
            <div class="registration-form w-100">

                <section>
                    <!-- Name Container -->
                    <div class="row">
                        <section class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="exampleFormControlInput1" class="form-label">Gender</label>
                                <section>
                                    <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('gender')}">
                                        <span class="input-group-text" id="basic-addon1">
                                            <mat-icon>whatshot</mat-icon>
                                        </span>
                                        <select class="form-select" aria-label="Default select example"
                                            formControlName="gender">
                                            <option value="" selected>Select</option>
                                            @for (item of gender?.option; track $index) {
                                            <option [value]="item.optionStatement">{{item.optionStatement}}</option>
                                            }
                                        </select>
                                    </div>
                                </section>
                            </div>
                        </section>
                        <section class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="exampleFormControlInput1" class="form-label">Zip Code</label>
                                <section>
                                    <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('zipCode')}">
                                        <span class="input-group-text" id="basic-addon1">
                                            <mat-icon>type_specimen</mat-icon>
                                        </span>
                                        <input type="text" class="form-control" placeholder="type here"
                                            formControlName="zipCode" aria-label="zipCode"
                                            aria-describedby="basic-addon1">
                                    </div>
                                </section>
                            </div>

                        </section>
                    </div>
                    <div class="row">
                        <section class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="exampleFormControlInput1" class="form-label">Language</label>
                                <section>
                                    <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('language')}">
                                        <span class="input-group-text" id="basic-addon1">
                                            <mat-icon>whatshot</mat-icon>
                                        </span>
                                        <select (change)="onLanguageSelect($event)" class="form-select"
                                            aria-label="Default select example" formControlName="language">
                                            <option value="" selected>Select</option>
                                            <option [value]="language">{{language}}</option>
                                        </select>
                                    </div>
                                </section>
                            </div>
                        </section>
                        <section class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="exampleFormControlInput1" class="form-label">Date of Birth</label>
                                <section>
                                    <div class="input-group" [ngClass]="{ 'border-danger': isFieldInvalid('dob') }">
                                        <span class="input-group-text" id="basic-addon1">
                                            <mat-icon>cake</mat-icon>
                                        </span>
                                        <div class="date-input-wrapper">
                                            <input type="date" class="form-control" formControlName="dob" />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>
                    </div>

                    <div class="row">
                        <div class="form-group mb-2">
                            <label for="exampleFormControlInput1" class="form-label">Hear about opinion Edge</label>
                            <section>
                                <div class="input-group"
                                    [ngClass]="{'border-danger': isFieldInvalid('opinionEdgeHear')}">
                                    <span class="input-group-text" id="basic-addon1">
                                        <mat-icon>whatshot</mat-icon>
                                    </span>
                                    <select class="form-select" aria-label="Default select example"
                                        formControlName="opinionEdgeHear">
                                        <option value="" selected>Select</option>
                                        @for (item of hearAboutQuestion?.option; track $index) {
                                        <option [value]="item.optionStatement">{{item.optionStatement}}</option>
                                        }
                                    </select>
                                </div>
                            </section>
                        </div>
                    </div>


                </section>

                <!--Final Submit Button -->
                <section class="row">
                    <div class="col-md-12">
                        <section class="form-check">
                            <input class="form-check-input" type="checkbox" id="chkDefault"
                                formControlName="acceptTerms">
                            <label class="form-check-label" for="chkDefault">
                                I have read and agreed to
                                <a routerLink="/privacy-policy/terms-conditions" class="privacy-anchor">Terms &
                                    Conditions</a>
                                in the <a routerLink="/privacy-policy" class="privacy-anchor mx-1">Privacy Policy</a>
                            </label>
                        </section>
                    </div>
                </section>

                <div class="form-action">
                    <button type="submit" mat-stroked-button class="proceed-button form-control">Proceed</button>
                </div>
            </div>
        </form>
    </mat-dialog-content>
</div>